<template>
    <b-container fluid>
        <app-supervision-activity-header>Lista de Chequeo</app-supervision-activity-header>
        <b-row>
            <b-col>
                <app-contact-report-form redirect="supervisionIndexPage" :client-id="supervisionClient.id"></app-contact-report-form>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import SupervisionActivityHeader from '../SupervisionActivityHeader';
import ContactReportForm from '../../Clients/ClientContacts/ContactReports/ContactReportForm/ContactReportForm.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        appSupervisionActivityHeader: SupervisionActivityHeader,
        appContactReportForm: ContactReportForm
    },
    computed: {
        ...mapGetters(['supervisionClient'])
    },
}
</script>